import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useAsyncFn } from 'react-use';
import { bindActionCreators } from 'redux';

import { abeCashupOwnCombinedRead } from 'actions/cashup/beCashup.action';
import beCashupAndReconcile from 'actions/cashup/beCashupAndReconcile.action';
import { abeCashupVouchersRead } from 'actions/cashup/beCashupVoucher.action';
import { useCurrentSalonId } from 'providers/SalonBasicInfo.provider';
import { fromAnyDateToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';

import Cashup from 'cashup/Cashup.component';

const L = logger('CashupOwn');

const CashupOwn = (props) => {
  const { abeCashupVouchersRead, beCashupAndReconcile } = props ?? {};

  const salonId = useCurrentSalonId();

  const [{ error: errorCashup }, handleCashup] = useAsyncFn(
    async (ev) => {
      const options = { ...ev, beCashup: abeCashupOwnCombinedRead };
      const result = await beCashupAndReconcile(options);
      L.debug('handleCashup()', result, '<-', options, '<-', ev);
    },
    [beCashupAndReconcile],
  );

  const [{ error: errorVouchers }, handleVouchers] = useAsyncFn(
    async (...args) => {
      const [ev, bgn, end] = args; // to make it more readable

      const options = {
        bgn: ev?.bgn ?? bgn,
        end: ev?.end ?? end,
      };

      const result = await abeCashupVouchersRead(options);
      const json = result?.json;

      const bgnZulu = fromAnyDateToZulu(bgn);
      const endZulu = fromAnyDateToZulu(end);

      L.debug('handleVouchers()', { bgnZulu, endZulu, json, result, args, options });
    },
    [abeCashupVouchersRead],
  );

  useEffect(() => void L.unignore('()', 'handleVouchers:', handleVouchers(salonId)), [handleVouchers, salonId]);

  const error = errorVouchers || errorCashup;
  if (error) L.warn('()', error);

  return (
    <Cashup
      {...props}
      fetchVouchersSold={handleVouchers}
      beCashupAndReconcile={handleCashup}
      salonId={salonId}
      permission="own"
    />
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      beCashupAndReconcile,
      abeCashupVouchersRead,
    },
    dispatch,
  );

const CashupOwnHoc = connect(null, mapDispatchToProps)(CashupOwn);

export default CashupOwnHoc;
